export enum EFormInputError {
    FieldRequired = 'formErrors.fieldRequired',
    TimeFormat = 'formErrors.timeFormat',
    InvalidDateSequence = 'formErrors.invalidDateSequence',
}